import { ApiIntegrationType, MultiFieldType, PartyEntityType } from './generated';

// TODO: revisit this, check if we could use only the BE enums
export enum MultiFieldTypeFE {
  TEXT = MultiFieldType.TEXT,
  EMAIL = MultiFieldType.EMAIL,
  NUMBER = MultiFieldType.NUMBER,
  CURRENCY = MultiFieldType.CURRENCY,
  CURRENCY_DURATION = MultiFieldType.CURRENCY_DURATION,
  SELECT = MultiFieldType.SELECT,
  DATE = MultiFieldType.DATE,
  BOOL = MultiFieldType.BOOL,
  DURATION = MultiFieldType.DURATION,
  TEXTAREA = MultiFieldType.TEXTAREA,
  LIST = MultiFieldType.LIST,
  TIMESTAMP = MultiFieldType.TIMESTAMP,
  CLAUSE = MultiFieldType.CLAUSE,
  OTHER = 'other',
}

export enum ConditionOperator {
  EQUAL = 'equal',
  NOT_EQUAL = 'not_equal',
  GREATER_THAN = 'greater_than',
  LESS_THAN = 'less_than',
  GREATER_THAN_OR_EQUAL = 'greater_than_or_equal',
  LESS_THAN_OR_EQUAL = 'less_than_or_equal',
  AND = '&&',
  OR = '||',
  EMPTY = 'empty',
  NOT_EMPTY = 'not_empty',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
}

export enum PartyBrickFormat {
  NAME = 'name',
  ADDRESS = 'address',
  ADDRESS_INLINE = 'address:inline',
  REFERENCE = 'reference',
}

export enum DocumentRevisionChangeType {
  DOCUMENT_PROSEMIRROR_DATA_CHANGED = 'document_prosemirror_data_changed',
  PARTY_CREATED = 'party_created',
  PARTY_CHANGED = 'party_changed',
  PARTY_DELETED = 'party_deleted',
  DOCUMENT_USER_CHANGED = 'document_user_changed',
  DOCUMENT_USER_CREATED = 'document_user_created',
  DOCUMENT_USER_DELETED = 'document_user_deleted',
  DYNAMIC_FIELD_CHANGED = 'dynamic_field_changed',
  SIGNATURE_CREATED = 'signature_created',
}

export enum DocumentWorkflowState {
  DOCUMENT_TRASHED = 'document_trashed',
  DOCUMENT_ARCHIVED = 'document_archived',
  IN_APPROVED_STAGE = 'in_approved_stage',
  IN_SIGNING_STAGE = 'in_signing_stage',
  HAS_ACTIVE_CHECKPOINT_PASSES = 'has_active_checkpoint_passes',
  HAS_ACTIVE_WORKING_COPY = 'has_active_working_copy',
  LOCKED = 'locked',
  NO_DOCUMENT_USER = 'no_document_user',
  ALL_PROPOSALS_RESOLVED = 'all_proposals_resolved',
  CAN_START_SIGNING = 'can_start_signing',
  MDU_CAN_START_SIGNING = 'mdu_can_start_signing',
}

export enum MetadataValueStatus {
  MISSING_INFORMATION = 'missing_information',
  CONFLICTING_INFORMATION = 'conflicting_information',
  NOT_APPLICABLE = 'not_applicable',
  COMPUTED = 'computed',
}

export enum ContractDurationType {
  OPEN_ENDED = 'open_ended',
  FIXED_TERM = 'fixed_term',
  NO_TERM = 'no_term',
}

export enum MainContentTab {
  DOCUMENT_CONTENT = 'document-content',
  SUMMARY = 'summary',
  ATTACHMENTS = 'attachments',
}

export enum ProposedChangeTab {
  ALL = 'all',
  PARTIES = 'parties',
  DATES = 'dates',
  METADATA = 'metadata',
  CLAUSES = 'clauses',
  SUGGESTIONS = 'suggestions',
}

export enum DynamicContentTab {
  DYNAMIC_FIELDS = 'dynamic_fields',
  CONDITIONS = 'conditions',
}

export enum ActivityTab {
  ACTIVITY_LOG = 'activity_log',
  ACCESSS_LOG = 'access_log',
  SIGNATURES = 'signatures',
}

export enum EditorContentTab {
  DYNAMIC_FIELDS = 1,
  PARTIES = 2,
  SIGNATURE_BLOCKS = 3,
}

export enum DiscussionTab {
  OPEN = 1,
  RESOLVED = 2,
}

export enum SignatureTab {
  CURRENT = 1,
  ARCHIVED = 2,
}

export enum CheckpointTab {
  PLAYBOOKS = 'playbooks',
  CHECKPOINTS = 'checkpoints',
  ARCHIVE = 'archive',
}

export enum DocumentTab {
  SIGNATURES = 'signatures',
  DOCUMENT_CONTENT = 'document-content',
  GENERAL = 'general',
  DATES = 'dates',
  METADATA = 'metadata',
  DYNAMIC_CONTENT = 'dynamic-content',
  PARTIES = 'parties',
  DISCUSSIONS = 'discussions',
  FILE_STORAGE = 'file-storage',
  ACTIVITY = 'activity',
  NOTIFICATIONS = 'notifications',
  CHECKPOINTS = 'checkpoints',
  LINKED = 'linked',
}

export enum PlaybookConditionResultStatus {
  NOT_FULFILLED = 'not_fulfilled',
  FULFILLED = 'fulfilled',
  UNDEFINED = 'undefined',
}

export enum TemplateTab {
  DOCUMENT_CONTENT = 'document-content',
  GENERAL = 'general',
  DATES = 'dates',
  METADATA = 'metadata',
  DYNAMIC_CONTENT = 'dynamic-content',
  SHARING = 'sharing',
  PARTIES = 'parties',
  CHECKPOINTS = 'checkpoints',
  FILE_STORAGE = 'file-storage',
  NOTIFICATIONS = 'notifications',
  MAPPING = 'mapping',
}

export enum DashboardTab {
  GENERAL = 'general',
  WIDGETS = 'widgets',
  FILTER = 'filter',
}

export enum DocumentCalendarEntryType {
  EXPIRATION = 'expiration_date',
  TERMINATED = 'terminated_date',
  RENEWAL = 'auto_renewal',
  NOTICE = 'cancellation_notice_date',
  EFFECTIVE = 'effective_date',
  DURATION_START = 'duration_start_date',
  DURATION_END = 'duration_end_date',
}

export enum EntityOrigin {
  SYSTEM = 'system',
  ACCOUNT = 'account',
  OVERRIDE = 'override',
}

export enum DocumentRelationshipRole {
  CONTROLLER = 'controller',
  PERIPHERAL = 'peripheral',
}

export enum DurationTypeRelatedMetadata {
  DURATION_START_DATE = 'duration_start_date',
  DURATION_END_DATE = 'duration_end_date',
  RENEWAL_DURATION = 'renewal_duration',
  DURATION_TERM = 'duration_term',
  CANCELLATION_NOTICE_PERIOD = 'cancellation_notice_period',
  CANCELLATION_NOTICE_DATE = 'cancellation_notice_date',
  EXPIRATION_DATE = 'expiration_date',
  TERMINATED_DATE = 'terminated_date',
  EFFECTIVE_DATE = 'effective_date',
}

// TODO: revisit this, check if we could use only the BE enums
export enum PartyEntityTypeFE {
  BUSINESS = PartyEntityType.BUSINESS,
  PERSON = PartyEntityType.PERSON,
  TBD = 'tbd',
}

export enum CrudContext {
  DOCUMENT = 'document',
  TEMPLATE = 'template',
}

export enum ExtendedCrudContext {
  DOCUMENT = CrudContext.DOCUMENT,
  TEMPLATE = CrudContext.TEMPLATE,
  PLAYBOOK = 'playbook',
}

export enum ImageCrudContext {
  DOCUMENT = 'document',
  TEMPLATE = 'template',
  HEADER_FOOTER = 'document-header-footer',
}

export enum ChartType {
  BAR = 'bar',
  COLUMN = 'column',
  PIE = 'pie',
  DONUT = 'donut',
  LINE = 'line',
  NUMBER = 'number',
  LIST = 'list',
}
export enum AllWidgetsKeys {
  tasks = 'tasks',
  documentsByStage = 'documentsByStage',
  documentsByTeam = 'documentsByTeam',
  documentsByTemplate = 'documentsByTemplate',
  documentList = 'documentList',
  documentCalendar = 'documentCalendar',
  createdDocuments = 'createdDocuments',
  signedDocuments = 'signedDocuments',
  upcomingWorkload = 'upcomingWorkload',
  contractValues = 'contractValues',
  custom = 'custom',
  clauses = 'clauses',
  parties = 'parties',
  quickstart = 'quickstart',
}

export enum WidgetNumberMetric {
  SUM = 'sum',
  AVERAGE = 'average',
  MEDIAN = 'median',
  HIGHEST = 'highest',
  LOWEST = 'lowest',
}

// TODO: https://gitlab.com/fynk/fynk/-/issues/2725
export enum SubscriptionTypeFE {
  INTERNAL = 'internal-subscription',
  TRIAL = 'trial-subscription',
  PAID = 'subscription',
  FREE = 'free-subscription',
}

export enum DurationOption {
  DAY = 'D',
  WEEK = 'W',
  MONTH = 'M',
  YEAR = 'Y',
}

export enum CurrencyDurationOption {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum MetadataTab {
  ALL = 'all',
  ACCOUNT = 'account',
  REFERENCE = 'reference',
  SYSTEM = 'system',
}

export enum DocumentNotificationType {
  EVENT = 'event',
  REMINDER = 'reminder',
  RECURRING = 'recurring',
}

export enum DashboardDefaultKey {
  PERSONAL = 'personal',
  ACCOUNT = 'account',
}

export enum JuneEvents {
  DOCUMENT_SAVED_AS_DOCX = 'document_saved_as_docx',
  TABLE_KANBAN_USED = 'table_kanban_used',
  EDITOR_PAGE_BREAK_INSERTED = 'editor_page_break_inserted',
  EDITOR_TABLE_OF_CONTENTS_INSERTED = 'editor_table_of_contents_inserted',
  EDITOR_TEXT_GENERATED_VIA_AI = 'editor_text_generated_via_ai',
  EDITOR_SECTION_REF_INSERTED = 'editor_section_ref_inserted',
  EDITOR_DYNAMIC_FIELD_INSERTED = 'editor_dynamic_field_inserted',
  EDITOR_DYNAMIC_FIELD_DROPPED = 'editor_dynamic_field_dropped',
  EDITOR_VARIABLE_INSERTED = 'editor_variable_inserted',
  EDITOR_VARIABLE_DROPPED = 'editor_variable_dropped',
  EDITOR_PARTY_INSERTED = 'editor_party_inserted',
  EDITOR_PARTY_DROPPED = 'editor_party_dropped',
  EDITOR_COLUMNS_INSERTED = 'editor_columns_inserted',
  EDITOR_IMAGE_INSERTED = 'editor_image_inserted',
  EDITOR_IMAGE_DROPPED = 'editor_image_dropped',
  EDITOR_IMAGE_PASTED = 'editor_image_pasted',
  EDITOR_SIGNATURE_BLOCK_DROPPED = 'editor_signature_block_dropped',
  EDITOR_SIGNATURE_BLOCK_PASTED = 'editor_signature_block_pasted',
  EDITOR_SIGNATURE_CONTAINER_INSERTED = 'editor_signature_container_inserted',
  EDITOR_SIGNING_VOTE_BLOCK_INSERTED = 'editor_signing_vote_block_inserted',
  EDITOR_SIGNING_VOTE_BLOCK_DROPPED = 'editor_signing_vote_block_dropped',
  EDITOR_SIGNING_VOTE_BLOCK_PASTED = 'editor_signing_vote_block_pasted',
  EDITOR_DOCX_IMPORTED_TEMPLATE = 'editor_docx_imported_template',
  EDITOR_AI_TEXT_GENERATED = 'editor_ai_text_generated',
  EDITOR_AI_TEXT_COMPLETED = 'editor_ai_text_completed',
  INSERT_VARIABLE = 'insert_variable',
  CMD_K_PRESSED = 'cmd_k_pressed',
  CMD_I_PRESSED = 'cmd_i_pressed',
}

export enum TaskableType {
  DOCUMENT = 'App\\Models\\Document',
  TEMPLATE = 'App\\Models\\Template',
  IMPORT = 'App\\Models\\Import',
  AUTOMATION = 'App\\Models\\Automation',
}

export enum MagicTableAllState {
  PAGE = 'page',
  ALL = 'all',
  NONE = 'none',
}

export enum EidEasyMethod {
  AUSTRIAN_HANDY_SIGNATUR = 'austrian-handy-signatur',
  DIIA = 'diia',
  ESTONIAN_MOBILE_ID = 'estonian-mobile-id',
  D_TRUST_SIGN_ME = 'd-trust-sign-me',
  ZEAL_ID = 'zeal-id',
  EVROTRUST = 'evrotrust',
  SWISSCOM_MOBILE_ID = 'swisscom-mobile-id',
  FINNISH_TRUST_NETWORK = 'finnish-trust-network',
  E_PARAKSTS = 'e-paraksts',
  NORWEGIAN_BANK_ID = 'norwegian-bank-id',
  SWEDISH_BANK_ID = 'swedish-bank-id',
  FREJA = 'freja',
  ITSME = 'itsme',
  SPID = 'spid',
  SPID_HASH = 'spid-hash',
  SIMPLY_SIGN = 'simply-sign',
  VERIMI = 'verimi',
  MIT_ID = 'mit-id',
  /*   MIT_ID_AES = 'mit-id-aes', */
  MIT_ID_INTESI = 'mit-id-intesi',
  BUYPASS = 'buypass',
  CERT_ME = 'certme',
  CERTSIGN_USB = 'certsign-usb',
  CERTSIGN_WEB_PAPERLESS = 'certsign-web-paperless',
  HR_ID = 'hr-id',
  ADACOM = 'adacom-one-shot-qes-signature',
}

export enum TrafficLightStatus {
  GREEN = 'green',
  ORANGE = 'orange',
  RED = 'red',
  GRAY = 'gray',
}

export enum ApiIntegrationDataType {
  BASE64 = 'base64',
  BOOLEAN = 'boolean',
  BYTE = 'byte',
  DATE = 'date',
  DATETIME = 'datetime',
  DOUBLE = 'double',
  INT = 'int',
  NUMBER = 'number',
  LONG = 'long',
  STRING = 'string',
  TIME = 'time',
  ADDRESS = 'address',
  ANYTYPE = 'anyType',
  CALCULATED = 'calculated',
  COMBOBOX = 'combobox',
  CURRENCY = 'currency',
  DATACATEGORYGROUPREFERENCE = 'dataCategoryGroupReference',
  EMAIL = 'email',
  ENCRYPTEDSTRING = 'encryptedstring',
  FLOATARRAY = 'floatArray',
  ID = 'id',
  JUNCTIONIDLIST = 'junctionIdList',
  LOCATION = 'location',
  MASTERRECORD = 'masterrecord',
  MULTIPICKLIST = 'multipicklist',
  PERCENT = 'percent',
  PHONE = 'phone',
  PICKLIST = 'picklist',
  REFERENCE = 'reference',
  TEXTAREA = 'textarea',
  URL = 'url',
  ENUM = 'enumeration',
}

export enum ApiIntegrationObjectMappableType {
  DOCUMENT = 'App\\Models\\Document',
  TEMPLATE = 'App\\Models\\Template',
  DYNAMIC_FIELD = 'App\\Models\\DynamicField',
  PARTY = 'App\\Models\\Party',
  METADATA_VALUE = 'App\\Models\\MetadataValue',
}

export enum ExtendedApiIntegrationType {
  SALESFORCE = ApiIntegrationType.SALESFORCE,
  HUBSPOT = ApiIntegrationType.HUBSPOT,
  PIPEDRIVE = ApiIntegrationType.PIPEDRIVE,
  EXTERNAL_API = 'api',
  SAML = 'saml',
  SCIM = 'scim',
}

export enum TriggerTimeConditionTypeOption {
  BEFORE = 'before',
  AFTER = 'after',
}

export enum JumpToSignatureElement {
  SIGNATURE_BLOCK = 'signature_block',
  SIGNING_VOTE_BLOCK = 'signing_vote_block',
}

export enum FynkyMainMode {
  SEARCH = 'search',
  FILE = 'file',
  IMAGE_CROPPER = 'imageCropper',
}

export enum FynkyFileActionKey {
  UPLOAD_DOCUMENTS = 'uploadDocuments',
  CREATE_DOCUMENT_FROM_DOCX = 'createDocumentFromDocx',
  CREATE_TEMPLATE_FROM_DOCX = 'createTemplateFromDocx',
  SET_PROFILE_PICTURE = 'setProfilePicture',
  SET_ACCOUNT_LOGO = 'setAccountLogo',
}
